(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-purchase-card-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ps-purchase-card')) {
    class PlanetshopPurchaseCard extends HTMLElement {
      connectedCallback() {
        this.frame = 0;
        this.observer = new MutationObserver(() => this.scheduleUpdate());
        this.observer.observe(this, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-busy', 'class']
        });
        this.updateButton();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.updateButton();
        });
      }

      updateButton() {
        const button = this.querySelector('#rsi_buy_now_button');
        if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
        const secondary = button.querySelector('p');
        const label = secondary?.parentElement;
        if (!label) return;
        const primary = Array.from(label.childNodes).find(node =>
          node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        if (!primary) return;
        const orderLabel = this.dataset.orderLabel;
        const paymentLabel = this.dataset.paymentLabel;
        if (primary.textContent.trim() !== orderLabel) primary.textContent = orderLabel;
        if (secondary.textContent !== paymentLabel) secondary.textContent = paymentLabel;
        if (!button.classList.contains('ps-purchase-card__button')) button.classList.add('ps-purchase-card__button');
        const accessibleLabel = orderLabel + '. ' + paymentLabel;
        if (button.getAttribute('aria-label') !== accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
        const help = this.querySelector('.ps-purchase-card__help');
        if (help) {
          const ids = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          if (!ids.includes(help.id)) button.setAttribute('aria-describedby', [...ids, help.id].join(' '));
        }
      }
    }

    customElements.define('ps-purchase-card', PlanetshopPurchaseCard);

    document.addEventListener('click', event => {
      const trigger = event.target instanceof Element
        ? event.target.closest('.sticky-atc__scroll-btn, .ps-close__cta')
        : null;
      if (!trigger) return;
      let card;
      if (trigger.classList.contains('ps-close__cta')) {
        const href = trigger.getAttribute('href') || '';
        if (!href.startsWith('#ps-purchase-')) return;
        card = document.getElementById(href.slice(1));
      } else {
        card = trigger.closest('[id^="MainProduct-"]')?.querySelector('ps-purchase-card');
      }
      if (!(card instanceof PlanetshopPurchaseCard)) return;
      const button = card.querySelector('#rsi_buy_now_button');
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true' || !button.getClientRects().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      button.click();
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
